import {
    COMMUNICATIONPROGRAM_BEGIN,
    COMMUNICATIONPROGRAM_SUCCESS,
    COMMUNICATIONPROGRAM_FAILURE,
    CLEAR_COMMUNICATIONPROGRAM,

    COMMUNICATIONPROGRAM_FILTER_SUCCESS,
    COMMUNICATIONPROGRAM_FILTER_BEGIN,
    COMMUNICATIONPROGRAM_FILTER_FAILURE,
    COMMUNICATIONPROGRAM_FILTER_CLEAR,

    COMMUNICATIONPROGRAM_DIFFUSION_SUCCESS,
    COMMUNICATIONPROGRAM_DIFFUSION_BEGIN,
    COMMUNICATIONPROGRAM_DIFFUSION_FAILURE,
    COMMUNICATIONPROGRAM_DIFFUSION_CLEAR,

    COMMUNICATIONPROGRAM_COURSE_SUCCESS,
    COMMUNICATIONPROGRAM_COURSE_BEGIN,
    COMMUNICATIONPROGRAM_COURSE_FAILURE,
    COMMUNICATIONPROGRAM_COURSE_CLEAR,

    COMMUNICATIONPROGRAM_COURSEAVAILABLE_SUCCESS,
    COMMUNICATIONPROGRAM_COURSEAVAILABLE_BEGIN,
    COMMUNICATIONPROGRAM_COURSEAVAILABLE_FAILURE,
    COMMUNICATIONPROGRAM_COURSEAVAILABLE_CLEAR,

    COMMUNICATION_DISPATCH_FILTER_BEGIN,
    COMMUNICATION_DISPATCH_FILTER_SUCCESS,
    COMMUNICATION_DISPATCH_FILTER_FAILURE,
    COMMUNICATION_DISPATCH_FILTER_CLEAR,

    COMMUNICATION_PROGRAM_SUMMARY_SUCCESS,
    COMMUNICATION_PROGRAM_SUMMARY_BEGIN,
    COMMUNICATION_PROGRAM_SUMMARY_FAILURE,
    CLEAR_COMMUNICATION_PROGRAM_SUMMARY,

    COMMUNICATION_PROGRAM_SUMMARY_FILTERS_SUCCESS,
    COMMUNICATION_PROGRAM_SUMMARY_FILTERS_BEGIN,
    COMMUNICATION_PROGRAM_SUMMARY_FILTERS_FAILURE,
    CLEAR_COMMUNICATION_PROGRAM_SUMMARY_FILTERS,

    COMMUNICATION_GRAPHICS_BEGIN,
    COMMUNICATION_GRAPHICS_SUCCESS,
    COMMUNICATION_GRAPHICS_FAILURE,
    CLEAR_COMMUNICATION_GRAPHICS,

    COMMUNICATION_PROGRAM_DETAILS_SUCCESS,
    COMMUNICATION_PROGRAM_DETAILS_BEGIN,
    COMMUNICATION_PROGRAM_DETAILS_FAILURE,
    CLEAR_COMMUNICATION_PROGRAM_DETAILS,

    COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_REQUEST,
    COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_SUCCESS,
    COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_FAILURE,
    CLEAR_COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE,

    GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_REQUEST,
    GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_SUCCESS,
    GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_FAILURE,
    CLEAR_COMMUNICATION_COLLABORATE_BY_JOB,

    GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_REQUEST,
    GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_SUCCESS,
    GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_FAILURE,
    CLEAR_COMMUNICATION_COLLABORATE_BY_IDEMPLOYEE,

    GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_REQUEST,
    GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_SUCCESS,
    GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_FAILURE,
    GET_CLEAR_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED,

    EXPORT_CA_FAILURE,
    EXPORT_CA_SUCCESS,
    EXPORT_CA_REQUEST,

    EXPORT_LAYOUT_REQUEST,
    EXPORT_LAYOUT_SUCCESS,
    EXPORT_LAYOUT_FAILURE,

    VALIDATE_LAYOUT_REQUEST,
    VALIDATE_LAYOUT_SUCCESS,
    VALIDATE_LAYOUT_FAILURE
} from 'app/actions/CommunicationProgramActions';

const initialState = {
    byId: {},
    allIds: [],
    allCommunicationProgramDiffusion: [],
    allCommunicationProgramCourse: [],
    allCommunicationProgramCourseAvailable: [],
    filterData: [],
    filterDispatch: {},
    CPSummary: [],
    CPSummaryFilters: [],
    graphs: {},
    CPDetails: [],
    TotalRows: 0,
    isLoading: false,
    isLoadingCourse: false,
    isLoadingCourseAvailable: false,
    listExternalEmployees: [],
    isLoadingExternalEmployees: false,
    listEmployeesByCategory: [],
    isLoadingEmployeesByCatagory: false,
    listEmployeesByIdEmployee: [],
    isLoadListEmployeesById: false,
    listAssignedEmployeesByIdEmployee: [],
    isLoadingAssignedEmployeesByIdEmployee: false,

    listEmployeesByIdEmployeeAssig: [],
    isLoadListEmployeesByIdAssig: false,

    listExternalEmployeesAssig: [],
    isLoadingExternalEmployeesAssig: false,
    isLoadingDiffusion: false,

    isLoadingCAExport: false,

    isExportingLayout: false,
    isValidatingLayout: false,
};

export default function CommunicationPrograms(state = initialState, action) {
    switch (action.type) {
        case COMMUNICATIONPROGRAM_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COMMUNICATIONPROGRAM_SUCCESS:
            let allIds = action.payload.data.Data;
            let TotalRows = action.payload.data.TotalRows;
            let byId = {
                ...state.byId
            };
            return {
                ...state,
                allIds,
                byId,
                TotalRows,
                isLoading: false,
            };
        case CLEAR_COMMUNICATIONPROGRAM:
            return {
                ...state,
                byId: {},
                allIds: [],
                isLoading: false,
            }
        case COMMUNICATIONPROGRAM_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case COMMUNICATIONPROGRAM_DIFFUSION_BEGIN:
            return {
                ...state,
                isLoadingDiffusion: true
            }
        case COMMUNICATIONPROGRAM_DIFFUSION_SUCCESS:
            let allCommunicationProgramDiffusion = [...new Set(state.allCommunicationProgramDiffusion.concat(action.payload.data.all))];

            return {
                ...state,
                allCommunicationProgramDiffusion,
                isLoadingDiffusion: false,
            };
        case COMMUNICATIONPROGRAM_DIFFUSION_CLEAR:
            return {
                ...state,
                allCommunicationProgramDiffusion: [],
                isLoadingDiffusion: false,
            }
        case COMMUNICATIONPROGRAM_DIFFUSION_FAILURE:
            return {
                ...state,
                isLoadingDiffusion: false
            }

        case COMMUNICATIONPROGRAM_COURSE_BEGIN:
            return {
                ...state,
                isLoadingCourse: true
            }
        case COMMUNICATIONPROGRAM_COURSE_SUCCESS:
            let allCommunicationProgramCourse = [...new Set(state.allCommunicationProgramCourse.concat(action.payload.data.all))];

            return {
                ...state,
                allCommunicationProgramCourse,
                isLoadingCourse: false,
            };
        case COMMUNICATIONPROGRAM_COURSE_CLEAR:
            return {
                ...state,
                allCommunicationProgramCourse: [],
                isLoadingCourse: false,
            }
        case COMMUNICATIONPROGRAM_COURSE_FAILURE:
            return {
                ...state,
                isLoadingCourse: false
            }

        case COMMUNICATIONPROGRAM_COURSEAVAILABLE_BEGIN:
            return {
                ...state,
                isLoadingCourseAvailable: true
            }
        case COMMUNICATIONPROGRAM_COURSEAVAILABLE_SUCCESS:
            let allCommunicationProgramCourseAvailable = [...new Set(state.allCommunicationProgramCourseAvailable.concat(action.payload.data.all))];

            return {
                ...state,
                allCommunicationProgramCourseAvailable,
                isLoadingCourseAvailable: false,
            };
        case COMMUNICATIONPROGRAM_COURSEAVAILABLE_CLEAR:
            return {
                ...state,
                allCommunicationProgramCourseAvailable: [],
                isLoadingCourseAvailable: false,
            }
        case COMMUNICATIONPROGRAM_COURSEAVAILABLE_FAILURE:
            return {
                ...state,
                isLoadingCourseAvailable: false
            }
        case COMMUNICATIONPROGRAM_FILTER_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COMMUNICATIONPROGRAM_FILTER_SUCCESS:
            let filterData = [...new Set(state.filterData.concat(action.payload.filterData))];
            return {
                ...state,
                filterData,
                isLoading: false,
            };
        case COMMUNICATIONPROGRAM_FILTER_CLEAR:
            return {
                ...state,
                filterData: [],
                isLoading: false,
            }
        case COMMUNICATIONPROGRAM_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case COMMUNICATION_DISPATCH_FILTER_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COMMUNICATION_DISPATCH_FILTER_SUCCESS:
            let filterDispatch = action.payload.filterDispatch;
            return {
                ...state,
                filterDispatch,
                isLoading: false,
            };
        case COMMUNICATION_DISPATCH_FILTER_CLEAR:
            return {
                ...state,
                filterDispatch: {},
                isLoading: false,
            }
        case COMMUNICATION_DISPATCH_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false
            }

        case COMMUNICATION_PROGRAM_SUMMARY_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COMMUNICATION_PROGRAM_SUMMARY_SUCCESS:
            let CPSummary = action.payload.data.Data;
            return {
                ...state,
                CPSummary,
                isLoading: false,
            };
        case CLEAR_COMMUNICATION_PROGRAM_SUMMARY:
            return {
                ...state,
                CPSummary: [],
                isLoading: false,
            }
        case COMMUNICATION_PROGRAM_SUMMARY_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case COMMUNICATION_PROGRAM_SUMMARY_FILTERS_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COMMUNICATION_PROGRAM_SUMMARY_FILTERS_SUCCESS:

            let CPSummaryFilters = action.payload.data;
            return {
                ...state,
                CPSummaryFilters,
                isLoading: false,
            };
        case CLEAR_COMMUNICATION_PROGRAM_SUMMARY_FILTERS:
            return {
                ...state,
                CPSummaryFilters: [],
                isLoading: false,
            }
        case COMMUNICATION_PROGRAM_SUMMARY_FILTERS_FAILURE:
            return {
                ...state,
                isLoading: false
            }

        case COMMUNICATION_GRAPHICS_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COMMUNICATION_GRAPHICS_SUCCESS:
            let graphs = action.payload.data;
            return {
                ...state,
                graphs,
                isLoading: false,
            };
        case COMMUNICATION_GRAPHICS_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case CLEAR_COMMUNICATION_GRAPHICS:
            return {
                ...state,
                graphs: {},
                isLoading: false,
            }
        case COMMUNICATION_PROGRAM_DETAILS_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COMMUNICATION_PROGRAM_DETAILS_SUCCESS:

            let CPDetails = action.payload.data.Data === null ? [] : action.payload.data.Data;
            return {
                ...state,
                CPDetails,
                isLoading: false,
            };
        case CLEAR_COMMUNICATION_PROGRAM_DETAILS:
            return {
                ...state,
                CPDetails: [],
                isLoading: false,
            }
        case COMMUNICATION_PROGRAM_DETAILS_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        //Obtener colaboradores externos para el programa de comunicación
        case COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_REQUEST:
            return {
                ...state,
                isLoadingExternalEmployees: true
            }
        case COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_SUCCESS:
            return {
                ...state,
                listExternalEmployees: action.payload,
                isLoadingExternalEmployees: false
            }
        case COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_FAILURE:
            return {
                ...state,
                isLoadingExternalEmployees: false
            }
        //Obtener colaboradores por puesto para el programa de comunicacion
        case GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_REQUEST:
            return {
                ...state,
                isLoadingEmployeesByCatagory: true
            }
        case GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_SUCCESS:
            return {
                ...state,
                listEmployeesByCategory: action.payload,
                isLoadingEmployeesByCatagory: false
            }
        case GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_FAILURE:
            return {
                ...state,
                isLoadingEmployeesByCatagory: false
            }
        //Obtener colaboradores por ficha para el programa de comunicacion
        case GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_REQUEST:
            return {
                ...state,
                isLoadListEmployeesById: true
            }
        case GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_SUCCESS:
            return {
                ...state,
                listEmployeesByIdEmployee: action.payload,
                isLoadListEmployeesById: false
            }
        case GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_FAILURE:
            return {
                ...state,
                isLoadListEmployeesById: false
            }
        //Obtener colaboradores por ficha asignados al programa de comunicacion
        case GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_REQUEST:
            return {
                ...state,
                isLoadingAssignedEmployeesByIdEmployee: true
            }
        case GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_SUCCESS:
            return {
                ...state,
                listAssignedEmployeesByIdEmployee: action.payload,
                isLoadingAssignedEmployeesByIdEmployee: false
            }
        case GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_FAILURE:
            return {
                ...state,
                isLoadingAssignedEmployeesByIdEmployee: false
            }
        case EXPORT_CA_REQUEST:
            return {
                ...state,
                isLoadingCAExport: true
            }
        case EXPORT_CA_SUCCESS:
            return {
                ...state,
                isLoadingCAExport: false
            }
        case EXPORT_CA_FAILURE:
            return {
                ...state,
                isLoadingCAExport: false
            }
        //Obtener layout empleados
        case EXPORT_LAYOUT_REQUEST:
            return {
                ...state,
                isExportingLayout: true
            }
        case EXPORT_LAYOUT_SUCCESS:
            return {
                ...state,
                isExportingLayout: false
            }
        case EXPORT_LAYOUT_FAILURE:
            return {
                ...state,
                isExportingLayout: false
            }
        case VALIDATE_LAYOUT_REQUEST:
            return {
                ...state,
                isValidatingLayout: true
            }
        case VALIDATE_LAYOUT_SUCCESS:
            return {
                ...state,
                isValidatingLayout: false
            }
        case VALIDATE_LAYOUT_FAILURE:
            return {
                ...state,
                isValidatingLayout: false
            }
        default:
            return state;
    }
};

export const getCommunicationProgram = state => {
    return state.allIds.map(i => Object.assign(i, { TotalRows: state.TotalRows }))
}
export const getIsLoadingCommunicationProgram = state => {
    return state.isLoading;
}

export const getCommunicationProgramDiffusion = state => {
    return state.allCommunicationProgramDiffusion;
}
export const getIsLoadingCommunicationProgramDiffusion = state => {
    return state.isLoading;
}

export const getCommunicationProgramCourse = state => {
    return state.allCommunicationProgramCourse;
}
export const getIsLoadingCommunicationProgramCourse = state => {
    return state.isLoadingCourse;
}

export const getCommunicationProgramCourseAvailable = state => {
    return state.allCommunicationProgramCourseAvailable;
}
export const getIsLoadingCommunicationProgramCourseAvailable = state => {
    return state.isLoadingCourseAvailable;
}

export const getCommunicationProgramFilter = state => {
    return state.filterData
}
export const getIsLoadingCommunicationProgramFilter = state => {
    return state.isLoading;
}

//COMMUNICATION DISPATCH FILTER
export const getCommunicationDispatchFilter = state => {
    return state.filterDispatch
}
export const getIsLoadingCommunicationDispatchFilter = state => {
    return state.isLoading;
}

//CommuncationProgramSumamry
export const getCommunicationsProgramSummary = state => {
    return state.CPSummary.map(i => Object.assign(i, { TotalRows: state.TotalRows }))
}
export const getIsLoadingCommunicationsProgramSummary = state => {
    return state.isLoading;
}
//CommuncationProgramSumamry
export const getCommunicationsProgramSummaryFilters = state => {
    return state.CPSummaryFilters
}
export const getIsLoadingCommunicationsProgramSummaryFilters = state => {
    return state.isLoading;
}

//Graphs
export const communicationGraphicsIsLoading = state => {
    return state.isLoading;
}
export const getCommunicationGraphics = state => {
    return state.graphs;
}

//CommuncationProgramDetails
export const getCommunicationsProgramDetails = state => {
    return state.CPDetails.map(i => Object.assign(i, { TotalRows: state.TotalRows }))
}
export const getIsLoadingCommunicationsProgramDetails = state => {
    return state.isLoading;
}

export const getExternalEmployeeState = state => {
    return state.listExternalEmployees;
}